import { LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY } from '../../../constants/storage'
import {
  getStorageSerializedItem,
  removeStorageItem,
} from '../../../utils/storage'

import {
  IDWELL_TO_IDWELL_OUTBOUND_COMPANY_ACTIVE_STATUS,
  ITEM_KEYS,
} from './IdwellToIdwellSubMenu.constants'

export function getSubMenuIdwellToIdwellActiveValue({
  outboundCompanies,
  value,
}) {
  return outboundCompanies.find(
    company =>
      company[ITEM_KEYS.selectedKey].toString() === value &&
      company[ITEM_KEYS.activeKey] ===
        IDWELL_TO_IDWELL_OUTBOUND_COMPANY_ACTIVE_STATUS
  )
}

export function getSubMenuIdwellToIdwellDefaultValue(outboundCompanies) {
  const prevActiveOutboundCompanyUuid = getStorageSerializedItem(
    LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY
  )
  const prevOutboundCompany = outboundCompanies.find(
    i => i[ITEM_KEYS.selectedKey] === prevActiveOutboundCompanyUuid
  )

  if (prevActiveOutboundCompanyUuid && prevOutboundCompany) {
    return prevOutboundCompany
  } else {
    removeStorageItem(LOCAL_STORAGE_IDWELL_TO_IDWELL_OUTBOUND_COMPANY_UUID_KEY)
  }

  return outboundCompanies[0]
}
